import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BACKEND_URL } from '@/lib/config';

const formatError = (detail) => typeof detail === 'string' ? detail : 'Não foi possível concluir a solicitação.';

export default function AuthAction({ purpose }) {
  const token = new URLSearchParams(useLocation().search).get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(purpose === 'verify');

  useEffect(() => {
    if (purpose !== 'verify') return;
    if (!token) {
      setError('O link está incompleto.');
      setLoading(false);
      return;
    }
    fetch(`${BACKEND_URL}/api/auth/verify-email`, {
      method: 'POST', headers: {'Content-Type':'application/json'},
      credentials: 'include', body: JSON.stringify({token})
    }).then(async response => {
      const data = await response.json();
      if (!response.ok) throw new Error(formatError(data.detail));
      setMessage(data.message);
    }).catch(err => setError(err.message)).finally(() => setLoading(false));
  }, [purpose, token]);

  const reset = async (event) => {
    event.preventDefault();
    setError('');
    if (!token) return setError('O link está incompleto.');
    if (password !== confirm) return setError('As senhas não coincidem.');
    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/reset-password`, {
        method:'POST', headers:{'Content-Type':'application/json'}, credentials:'include',
        body:JSON.stringify({token, password})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(formatError(data.detail));
      setMessage(data.message);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return <main className="blop-login min-h-screen flex items-center justify-center px-4 py-10">
    <section className="blop-login-card relative z-10 w-full max-w-md rounded-[28px] p-6 sm:p-8 text-center">
      <h1 className="blop-brand text-4xl font-extrabold mb-3">Blop<span>Boru</span><b>.</b></h1>
      <h2 className="text-xl font-bold mb-5">{purpose === 'verify' ? 'Confirmação de e-mail' : 'Nova senha'}</h2>
      {purpose === 'reset' && !message && <form onSubmit={reset} className="space-y-4 text-left">
        <input type="password" minLength="10" maxLength="128" required value={password} onChange={e=>setPassword(e.target.value)}
          placeholder="Nova senha (mínimo de 10 caracteres)" className="w-full bg-white/5 border border-white/10 rounded-xl p-3 text-white" />
        <input type="password" minLength="10" maxLength="128" required value={confirm} onChange={e=>setConfirm(e.target.value)}
          placeholder="Repita a nova senha" className="w-full bg-white/5 border border-white/10 rounded-xl p-3 text-white" />
        <button disabled={loading} className="blop-primary-button w-full rounded-xl py-3 font-bold">Atualizar senha</button>
      </form>}
      {loading && <p className="text-white/60">Verificando…</p>}
      {message && <p className="rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-4 text-emerald-200">{message}</p>}
      {error && <p className="rounded-xl border border-red-500/30 bg-red-500/10 p-4 text-red-300">{error}</p>}
      <Link to="/login" className="mt-6 inline-block text-sm font-semibold text-[#b99bf8] hover:text-white">Voltar ao login</Link>
    </section>
  </main>;
}
